export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 7\">\n    <path fill-rule=\"evenodd\" d=\"M4 0L8 7 0 7z\"/>\n</svg>\n";